export default __webpack_public_path__ + "static/media/carosel7.54aa158b.jpg";